import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { globalHistory } from '@reach/router';
import cx from 'classnames';
const Routes = require('../../routes').Routes;
import GTM from 'components/gtm';
import { COOKIES_ACCEPTED_KEY } from '../../../lib/constants';
import Cookies from 'js-cookie';
import styles from './cookies-modal.module.css';

const CookieModal = () => {
  const [isAccepted, setIsAccepted] = useState(true);

  const unsubscribe = globalHistory.listen(({ action }) => {
    if (action === 'PUSH') {
      acceptCookies();
      unsubscribe();
    }
  });

  useEffect(() => {
    setIsAccepted(Cookies.get(COOKIES_ACCEPTED_KEY) === 'true');
  }, []);

  const acceptCookies = () => {
    Cookies.set(COOKIES_ACCEPTED_KEY, 'true', { expires: 30 });
    setIsAccepted(true);
  };

  return (
    isAccepted || (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <p className={styles.text}>
            We use our own and third-party cookies to perform analysis of use and measurement of our
            website to improve our services. If you go on surfing, we will consider you accepting
            its use. You can change the settings or get more information{' '}
            <Link to={Routes.COOKIES} className={styles.link}>
              here
            </Link>
          </p>
          <button type="button" onClick={acceptCookies} className={cx('btn btn_60', styles.btn)}>
            Accept
          </button>
        </div>
      </div>
    )
  );
};

export default CookieModal;
